module.exports = __webpack_public_path__ + "static/media/arab10.661f0b67.wav";